const init = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const awards = $('.c-awards');
        const awardsWrapper = $('.c-awards .c-awards__wrap');
        if (!awardsWrapper.length) return;

        const show_all_link = awards.find('.c-awards__show-all');

        // Wait for the awards to be populated before applying functionality
        const waitForAwards = () => {
            const awardsLoaded = awardsWrapper.find('.c-awards__award').length > 0;

            if (!awardsLoaded) {
                requestAnimationFrame(waitForAwards);
                return;
            }

            // Event handler for "Show All" link
            show_all_link.on('click', function () {
                if (awardsWrapper.hasClass('is-open')) {
                    // Close: remove the is-open class to let CSS handle the hiding
                    awardsWrapper.removeClass('is-open');
                    show_all_link.text('Show all');
                } else {
                    // Open: add the is-open class to let CSS handle the showing
                    awardsWrapper.addClass('is-open');
                    show_all_link.text('Close');
                }
            });
        };

        waitForAwards();
    });
}

export default init;
